import classNames from 'classnames';
import { faqHowWeWorks } from 'data/showcase';
import { Accordion, Col, Row } from 'react-bootstrap';

const AboutTheFounder = () => {
  return (
    <section>
      <div className="container-small">
        <Row className="flex-center">
          <Col xs={12} xl={12}>
            <h2 className="text-center mb-6 mb-sm-10">About the Founder</h2>
            <p>
              <strong>“You cannot correct what you cannot measure.”</strong>{' '}
            </p>
            <p>
              That belief became the foundation of <strong>MLAS</strong>,
              Kuwait’s first culturally rooted AI nutrition-logging system.
            </p>

            <p>
              MLAS was founded by a{' '}
              <strong>
                Kuwaiti nutritionist and University of Leeds graduate
              </strong>
              , who earned her{' '}
              <strong>Bachelor’s degree with honors in Nutrition</strong>.
              During her{' '}
              <strong>internship at the Dasman Diabetes Institute (DDI)</strong>
              , she saw how traditional methods like the 24-hour recall and food
              frequency questionnaire (FFQ) were often{' '}
              <strong>
                tedious, inaccurate, and disconnected from local eating habits.
              </strong>
            </p>

            <p>
              Most international nutrition tools failed to capture the richness
              of Gulf cuisine — shared meals, mixed dishes, and cultural food
              traditions that shape daily life in Kuwait. That realization
              inspired the creation of <strong>MLAS:</strong> a smarter,
              culturally aware way to understand what we eat.
            </p>

            <p>
              The name <strong>MLAS (ملّاس)</strong> comes from the large
              serving spoon used across the Middle East — a symbol of food,
              generosity, and community. It reflects the founder’s belief that
              technology should honor tradition while improving how we live and
              eat.
            </p>

            <p>
              Today, MLAS helps dietitians and clients across Kuwait track
              meals, calculate nutrients, and uncover meaningful insights about
              their health. With each innovation, MLAS moves closer to its
              mission: to make nutrition tracking{' '}
              <strong>smarter, simpler, and more personal</strong> — helping
              Kuwait build a healthier future, one plate at a time.
            </p>
          </Col>
        </Row>
      </div>
    </section>
  );
};

export default AboutTheFounder;
